import { render, staticRenderFns } from "./ColorProperties.vue?vue&type=template&id=15beb992&scoped=true"
import script from "./ColorProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorProperties.vue?vue&type=style&index=0&id=15beb992&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15beb992",
  null
  
)

export default component.exports